<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_spy_intro')
}

const isOnSpiesSection = computed(() => {
  return route.path.startsWith('/diplomacy/spies')
})

const goToSpies = () => {
  router.push('/diplomacy/spies')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/spy.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.spy.intro.trainedFirst') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.spy.intro.allowsSteal') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.spy.intro.startsNovice') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.spy.intro.headOver') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.spy.intro.clickDiplomacyDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.spy.intro.clickDiplomacyMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnSpiesSection" @click="goToSpies" class="mr-2">
        {{ t('tutorial.spy.intro.goToSpies') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.spy.intro.gotIt') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>